import * as React from 'react';

import { UitkTextSkeleton } from 'uitk-react-skeleton';

import { ListDisplayFilterGroupLegend } from '.';

import { FlightsFilterSkeletonOptionType } from 'types/search/sort-filter';

interface SkeletonFilterGroupProps {
  disabled: boolean;
  filterOption: FlightsFilterSkeletonOptionType;
}

const skeletonWidthPattern = [29, 36];

export const SkeletonFilterGroup = ({ disabled, filterOption }: SkeletonFilterGroupProps) => (
  <fieldset className="all-b-margin-six" data-test-id="skeleton-filter-group">
    <ListDisplayFilterGroupLegend
      disabled={disabled}
      labelLegend={filterOption.label}
      secondaryLabel={filterOption.priceFromLabel}
    />
    {[...Array(filterOption.itemCount)].map((nullElem, index) => {
      const skeletonWidthValue = skeletonWidthPattern[index % skeletonWidthPattern.length];

      return (
        <div
          className="uitk-flex uitk-flex-justify-content-space-between all-b-margin-three all-t-margin-two"
          data-test-id="filter-skeleton"
          key={index}
        >
          <UitkTextSkeleton animation={true} width={skeletonWidthValue} />
          <UitkTextSkeleton animation={true} width={14} />
        </div>
      );
    })}
  </fieldset>
);
